import * as classNames from 'classnames';
import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss';
import { InjectedApiProps, withApi } from 'src/_context/Api';
import Responsive from 'src/_context/Responsive';
import { InjectedTransitionedContainerProps, withTransitionedContainer } from 'src/_context/TransitionedContainer';
import closeIcon from 'src/assets/icons/novo-close.svg';
import stylesheet, { directions } from 'src/constants/stylesheet';

export type CloseProps = {};
const styles = {
    menuIcon: {
        position: 'absolute',
        width: 15,
        transition: 'opacity .4s ease'
    },
    menuIconPositioning: {
        ...stylesheet.PostionGutter(1, directions.top | directions.right)
    },
    menuLink: {
        display: 'block',
        pointerEvents: 'initial'
    },
    hide: {
        opacity: 0
    }
};

type Props =
    CloseProps &
    InjectedTransitionedContainerProps &
    InjectedApiProps &
    StyledComponentProps<keyof typeof styles>;;

class Close extends React.Component<Props> {
    constructor(props: Props) {
        super(props);
    }

    render() {
        const { classes, transitionedContainer: { move }, apiCtx: { loading } } = this.props;
        return (
            <div className={classNames(classes!.menuIcon, classes!.menuIconPositioning)}>
                <Responsive.Consumer steps={['Mobile']}>
                    <a
                        className={classNames(classes!.menuLink, loading ? classes!.hide : '')}
                        // tslint:disable-next-line:jsx-no-lambda
                        onClick={() => move('menu')}
                        data-routed="true"
                    >
                        <img src={closeIcon} alt="Menu Icon image" />
                    </a>
                </Responsive.Consumer>
            </div>
        );
    }
}

export default withApi(withTransitionedContainer(withStyles(styles)(Close)));


// WEBPACK FOOTER //
// ./src/components/Close.tsx